<template>
  <div class="faq-wrapper">
    <div class="questions-wrapper section">
      <div class="section__inner">
        <container>
          <div class>
            <div class="subpage-header__title section__title">
              <span class="color-light-green">Frequently Asked</span> Questions
            </div>
          </div>

          <div class="hero-search">
            <div class="hero-search__left">
              <input
                type="text"
                placeholder="How can we help you?"
                @focusin="focus(true)"
                @focusout="focus(false)"
              />
            </div>
            <button
              :class="{ 'addFocusedButton': hasfocus }"
              class="button hero-search__submit green"
            >
              <span class="button__wrp">
                <span class="button__icon">
                  <svg viewBox="0 0 20 20" class="icon">
                    <use xlink:href="/icon/icons.svg#icon-search" />
                  </svg>
                </span>
                <span class="button__txt">SEARCH MOVIE</span>
              </span>
            </button>
          </div>

          <div class="subpage-accordion text-left" v-for="(faq, $faqIndex) in faqs" :key="faq.id">
            <div class="subpage-accordion__title color-light-green">
              <p class="subpage-accordion__title-text">{{ faq.title }}</p>
            </div>
            <div class="subpage-accordion__wrapper">
              <div
                class="subpage-accordion__item"
                :class="{ active : $index === currentAccordion && $faqIndex === currentSection }"
                v-for="(faq, $index) in faq.accordions"
                :key="faq.id"
              >
                <div class="subpage-accordion__header" @click="toggle($faqIndex, $index)">
                  <div
                    class="subpage-accordion__title subpage-accordion__title--right"
                  >{{ faq.title }}</div>
                  <span class="subpage-accordion__caret">
                    <svg-icon type="icon-arrow-down" />
                  </span>
                </div>
                <slide-up-down
                  :duration="600"
                  :active="$index === currentAccordion && $faqIndex === currentSection"
                >
                  <div class="subpage-accordion__cnt" v-html="faq.text"></div>
                </slide-up-down>
              </div>
            </div>
          </div>
        </container>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Faq",
  metaInfo() {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: "Frequently Asked Questions",
      link: [
        { rel: "canonical" },
        { href: window.location.origin + "/frequenlty-asked-questions/" }
      ]
    };
  },
  data() {
    return {
      currentAccordion: null,
      currentSection: null,
      hasfocus: false,
      faqs: [
        {
          id: 0,
          title: "Website Visitor",
          accordions: [
            {
              id: 0,
              title: "How should I search the movies?",
              text:
                "<p> The first feature to note is the &quot;score&quot; of the movie.	" +
                "However, it is better not to ignore your basic wishes while searching for a suitable movie. " +
                "What are these? <br><br> " +
                "First you should decide which kinds of movies you like, a comedy or a horror?" +
                " Which movies are playing in the area I am in? " +
                " Which studios, TV networks I am interested in? </p>",
              active: false
            },
            {
              id: 1,
              title: "How can I learn release dates of the movies that will be released??",
              text:
                "<p> You can view the release date by going to the detail page of the movie you want to review on HolywoodSkyline.com,  " +
                "or you contact the hall where it will be released for detailed information. " +
                "You can view the properties section on the detail page for the release dates information. </p>",
              active: false
            },
            {
              id: 2,
              title: "How many movies are there listed? ",
              text:
                "<p> With thousand of movie and tv show of each genre, our database is huge and its increasing day by day. You can see content numbers on each genre page under the title. </p> ",
              active: false
            },
            {
              id: 3,
              title:
                "Is the content on your site safe?",
              text:
                "<p> All the films recorded on our site are affiliated with the American film institution and have to be in compliance with the community standards since they are subject to auditing. </p>",
              active: false
            },
            {
              id: 4,
              title:
                "Is it safe to shop on your site ? Are security systems available?",
              text:
                "<p> Although not available on all websites, the vast majority of security measures are taken and are mandatory. " +
                "At least one of the security measures exists in many of them. Security services must be available for purchases. </p>",
              active: false
            },
            {
              id: 5,
              title:
                "What are the activity areas that can be done on the website? How is time evaluated on the site?",
              text:
                "<p> Movies own information, events (such as premier screenings) " +
                "Besides, there is a picture gallery, actor and producer staff for movies, similar movies are available in the advice section. " +
                "By choosing a good movie, it allows you to have a pleasant time with your family and friends at home.</p>",
              active: false
            },
            {
              id: 6,
              title:
                "Is there a content provider with which your website is contracted?",
              text:
                "<p> We use awar-winning movieDB database as content provider. </p>",
              active: false
            },
            {
              id: 7,
              title:
                "How can I reach the cinemas at the closest distance I have been on your site?",
              text:
                "<p> You can filter your searches by choosing a state, city, or neighborhood through the Holywoodskyline.com homepage. " +
                "You can narrow the search as much as your neighborhood by choosing a cinema on the page you are directed to and "+
                 "You can start to examine the nearest cinemas of the screening times you have chosen for your movie on the page.	</p>",
              active: false
            },
            {
              id: 8,
              title:
                "How can I reach the movie theaters in the city where I live from your site?",
              text:
                "<p> Click on the city from the top menu on the Holywoodskyline.com homepage or click "+
                 "You have just selected the city from the search bar and click on the search movie button" +
                 "You can view movies, theaters and screenings in the city.	</p>",
              active: false
            },
            {
              id: 9,
              title:
                "How can I reach the most suitable movie for my budget and taste from your site?",
              text:
                "<p> Choose your city, studio and movie type from the Holywoodskyline.com homepage and select your location on the page that opens " +
                "After selecting Click the &quot;Learn Movie Prices&quot; button and filling the form in the filter you selected " +
                "The movies are sent to us on your behalf free of charge. In this way, movie theaters "+
                 "provides you a return, you can reach the country in the criteria you are looking for in the fastest way. </p>",
              active: false
            },
          ]
        },
        {
          id: 1,
          title: "Content Owners",
          accordions: [
            {
              id: 0,
              title:
                "How can I promote my content impressively on your site?",
              text:
                "<p> Holywoodskyline.com is an industry-leading movie search portal that ranks first in search engines. " +
                "It acts as a bridge between the movie and the audience. " +
                "Therefore, when you are on our site, your information that is constantly updated, "+
                 "With your content and photos, you can better introduce yourself to your target audience. " +
                "Also, your contact information and transportation information with Holywoodskyline.com are correct "+
                 "Because it is constantly updated in some way, viewers are provided to reach you more quickly. </p>",
              active: false
            },
            {
              id: 1,
              title:
                "Why should I advertise? What is its contribution to my content after posting?",
              text:
                "<p> Holywoodskyline.com is the best real content search portal in the world. " +
                "Holywoodskyline.com, which ranks first in the search engines and is the industry leader "+
                 "It is a portal used by Holywood studios and many actors. " +
                "Included in the news in many national press by taking it as a reference to the audience <br><br> " +
                "As Holywoodskyline.com, the film and TV series are at the forefront of all search engines worldwide "+
                 "We act as a bridge between content and viewers in their searches." +
                "Your target audience, who use the communication tools effectively, "+
                 "He knows our site very well and reaches movies on Holywoodskyline.com. " +
                "There are currently over 100 thousand content on our site. And this number is increasing day by day. " +
                "The modern design of our site, easy to use and the features that movies want to highlight to the target audience "+
                 "for the fact that he is effectively telling and promoting the message he wants to give" +
                 "Your target audience provides the audience to be reached faster. </p>",
              active: false
            },
            {
              id: 2,
              title: "How long is the posting time on your site?",
              text:
                "<p> Advertising contracts on Holywoodskyline.com expire on 1 June as of your current date, " +
                "no matter what date you log into our site. New Contracts and ad renewals this "+
                 "is made from the date. If you want to advertise on our site after this date or "+
                 "contracts of content providers who give up will expire as of June 1 of the next year. </p>",
              active: false
            },
            {
              id: 3,
              title:
                "How can I get your web site advertising fees and pricing?",
              text:
                "<p> You can send a message to the advertising fees on our site by filling out the Contact Form section or by filling in the add country section. " +
                "Again, our communication phones can easily reach our site; " +
                "You can get detailed information about advertising areas and pricing by our authorized experts.</p>",
              active: false
            },
            {
              id: 4,
              title: "How visitors access my product through your site?",
              text:
                "<p> When visitors log into Holywoodskyline.com, they can choose the most convenient one for them in many ways that they can easily reach you.. " +
                "In addition, by selecting the studio with our search option in the studio made by the related studio "+
                 "they reach you quickly within the movies. Your company information in your ad content, "+
                 "your photos, features and contact phones, your whatsapp contact line. " +
                "They receive the necessary information they want to learn about price and film by sending a message from the  &quot;Subscribe &quot; section or by contacting you on your phones. </p>",
              active: false
            },
            {
              id: 5,
              title: "What are the movie search options on your site?",
              text:
                "<p> It is very easy for film lovers to find the movie that meets the criteria they are looking for. " +
                "Our site has the features of searching according to the &quot;series&quot; by choosing the studio and the network, choosing the type of show and the series according to the movie style.. Holywoodskyline.com is designed so that visitors can easily access the movie they are looking for using every search mode.. </p>",
              active: false
            },
            {
              id: 6,
              title:
                "Can I make changes to my information by logging in to my site with my member login?",
              text:
                "<p> You can update your information by logging into Holywoodskyline.com with your own member information; " +
                "you can change your photos, reply messages from visitors. </p>",
              active: false
            },
            {
              id: 7,
              title: "How can I learn the advertising fees?",
              text:
                "<p> You can reach the detailed information of the page you like by clicking the &quot;advertise& button.  " +
                "If you wish on the film detail page, you can fill out the form at no cost and ask us to call you. " +
                " Or you can contact us by clicking on the &quot;Call Us&quot; button" +
                " Or you can contact us via whatsapp by clicking the &quot;Whatsapp&quot; icon. </p>",
              active: false
            }            
          ]
        }
      ]
    };
  },
  methods: {
    toggle(faqIndex, index) {
      if (index === this.currentAccordion) {
        this.currentAccordion = null;
        this.currentSection = null;
      } else {
        this.currentAccordion = index;
        this.currentSection = faqIndex;
      }
    },
    focus(value) {
      this.hasfocus = value;
    },
  }
};
</script>

<style lang="scss">
@import "../assets/scss/components/questions";
.addFocusedButton {
  background: #4b5ba4 !important;
  box-shadow: 0px 8px 29px 0px rgba(75, 91, 164, 0.42) !important;
}
</style>
